/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppMoreRouteImport } from './routes/_app/more'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as AppBookingsBookingIdRouteImport } from './routes/_app/bookings/$bookingId'
import { Route as AppBookingsNewRouteImport } from './routes/_app/bookings/new'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAgreementsRouteImport } from './routes/_app/settings/agreements'
import { Route as AppSettingsDealershipRouteImport } from './routes/_app/settings/dealership'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsRetentionRouteImport } from './routes/_app/settings/retention'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsStaffRouteImport } from './routes/_app/settings/staff'
import { Route as AppVehiclesIndexRouteImport } from './routes/_app/vehicles/index'
import { Route as AppVehiclesVehicleIdRouteImport } from './routes/_app/vehicles/$vehicleId'
import { Route as AppVehiclesNewRouteImport } from './routes/_app/vehicles/new'
import { Route as AppBookingsBookingIdActiveRouteImport } from './routes/_app/bookings/$bookingId_.active'
import { Route as AppBookingsBookingIdAgreementRouteImport } from './routes/_app/bookings/$bookingId_.agreement'
import { Route as AppBookingsBookingIdConditionRouteImport } from './routes/_app/bookings/$bookingId_.condition'
import { Route as AppBookingsBookingIdContactRouteImport } from './routes/_app/bookings/$bookingId_.contact'
import { Route as AppBookingsBookingIdDriveRouteImport } from './routes/_app/bookings/$bookingId_.drive'
import { Route as AppBookingsBookingIdLicenceRouteImport } from './routes/_app/bookings/$bookingId_.licence'
import { Route as AppBookingsBookingIdReturnRouteImport } from './routes/_app/bookings/$bookingId_.return'
import { Route as AppDrivesDriveIdActiveRouteImport } from './routes/_app/drives/$driveId_.active'
import { Route as AppDrivesDriveIdAgreementRouteImport } from './routes/_app/drives/$driveId_.agreement'
import { Route as AppDrivesDriveIdReturnRouteImport } from './routes/_app/drives/$driveId_.return'
import { Route as AppVehiclesVehicleIdEditRouteImport } from './routes/_app/vehicles/$vehicleId_.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppMoreRoute = AppMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBookingsBookingIdRoute = AppBookingsBookingIdRouteImport.update({
  id: '/bookings/$bookingId',
  path: '/bookings/$bookingId',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingsNewRoute = AppBookingsNewRouteImport.update({
  id: '/bookings/new',
  path: '/bookings/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAgreementsRoute = AppSettingsAgreementsRouteImport.update({
  id: '/settings/agreements',
  path: '/settings/agreements',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDealershipRoute = AppSettingsDealershipRouteImport.update({
  id: '/settings/dealership',
  path: '/settings/dealership',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsRetentionRoute = AppSettingsRetentionRouteImport.update({
  id: '/settings/retention',
  path: '/settings/retention',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsStaffRoute = AppSettingsStaffRouteImport.update({
  id: '/settings/staff',
  path: '/settings/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppVehiclesIndexRoute = AppVehiclesIndexRouteImport.update({
  id: '/vehicles/',
  path: '/vehicles/',
  getParentRoute: () => AppRoute,
} as any)
const AppVehiclesVehicleIdRoute = AppVehiclesVehicleIdRouteImport.update({
  id: '/vehicles/$vehicleId',
  path: '/vehicles/$vehicleId',
  getParentRoute: () => AppRoute,
} as any)
const AppVehiclesNewRoute = AppVehiclesNewRouteImport.update({
  id: '/vehicles/new',
  path: '/vehicles/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingsBookingIdActiveRoute =
  AppBookingsBookingIdActiveRouteImport.update({
    id: '/bookings/$bookingId_/active',
    path: '/bookings/$bookingId/active',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookingsBookingIdAgreementRoute =
  AppBookingsBookingIdAgreementRouteImport.update({
    id: '/bookings/$bookingId_/agreement',
    path: '/bookings/$bookingId/agreement',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookingsBookingIdConditionRoute =
  AppBookingsBookingIdConditionRouteImport.update({
    id: '/bookings/$bookingId_/condition',
    path: '/bookings/$bookingId/condition',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookingsBookingIdContactRoute =
  AppBookingsBookingIdContactRouteImport.update({
    id: '/bookings/$bookingId_/contact',
    path: '/bookings/$bookingId/contact',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookingsBookingIdDriveRoute =
  AppBookingsBookingIdDriveRouteImport.update({
    id: '/bookings/$bookingId_/drive',
    path: '/bookings/$bookingId/drive',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookingsBookingIdLicenceRoute =
  AppBookingsBookingIdLicenceRouteImport.update({
    id: '/bookings/$bookingId_/licence',
    path: '/bookings/$bookingId/licence',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookingsBookingIdReturnRoute =
  AppBookingsBookingIdReturnRouteImport.update({
    id: '/bookings/$bookingId_/return',
    path: '/bookings/$bookingId/return',
    getParentRoute: () => AppRoute,
  } as any)
const AppDrivesDriveIdActiveRoute = AppDrivesDriveIdActiveRouteImport.update({
  id: '/drives/$driveId_/active',
  path: '/drives/$driveId/active',
  getParentRoute: () => AppRoute,
} as any)
const AppDrivesDriveIdAgreementRoute =
  AppDrivesDriveIdAgreementRouteImport.update({
    id: '/drives/$driveId_/agreement',
    path: '/drives/$driveId/agreement',
    getParentRoute: () => AppRoute,
  } as any)
const AppDrivesDriveIdReturnRoute = AppDrivesDriveIdReturnRouteImport.update({
  id: '/drives/$driveId_/return',
  path: '/drives/$driveId/return',
  getParentRoute: () => AppRoute,
} as any)
const AppVehiclesVehicleIdEditRoute =
  AppVehiclesVehicleIdEditRouteImport.update({
    id: '/vehicles/$vehicleId_/edit',
    path: '/vehicles/$vehicleId/edit',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/calendar': typeof AppCalendarRoute
  '/more': typeof AppMoreRoute
  '/notifications': typeof AppNotificationsRoute
  '/join/$token': typeof JoinTokenRoute
  '/s/$token': typeof STokenRoute
  '/bookings/$bookingId': typeof AppBookingsBookingIdRoute
  '/bookings/new': typeof AppBookingsNewRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/settings/agreements': typeof AppSettingsAgreementsRoute
  '/settings/dealership': typeof AppSettingsDealershipRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/retention': typeof AppSettingsRetentionRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/vehicles/$vehicleId': typeof AppVehiclesVehicleIdRoute
  '/vehicles/new': typeof AppVehiclesNewRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/vehicles/': typeof AppVehiclesIndexRoute
  '/bookings/$bookingId/active': typeof AppBookingsBookingIdActiveRoute
  '/bookings/$bookingId/agreement': typeof AppBookingsBookingIdAgreementRoute
  '/bookings/$bookingId/condition': typeof AppBookingsBookingIdConditionRoute
  '/bookings/$bookingId/contact': typeof AppBookingsBookingIdContactRoute
  '/bookings/$bookingId/drive': typeof AppBookingsBookingIdDriveRoute
  '/bookings/$bookingId/licence': typeof AppBookingsBookingIdLicenceRoute
  '/bookings/$bookingId/return': typeof AppBookingsBookingIdReturnRoute
  '/drives/$driveId/active': typeof AppDrivesDriveIdActiveRoute
  '/drives/$driveId/agreement': typeof AppDrivesDriveIdAgreementRoute
  '/drives/$driveId/return': typeof AppDrivesDriveIdReturnRoute
  '/vehicles/$vehicleId/edit': typeof AppVehiclesVehicleIdEditRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/calendar': typeof AppCalendarRoute
  '/more': typeof AppMoreRoute
  '/notifications': typeof AppNotificationsRoute
  '/join/$token': typeof JoinTokenRoute
  '/s/$token': typeof STokenRoute
  '/': typeof AppIndexRoute
  '/bookings/$bookingId': typeof AppBookingsBookingIdRoute
  '/bookings/new': typeof AppBookingsNewRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/settings/agreements': typeof AppSettingsAgreementsRoute
  '/settings/dealership': typeof AppSettingsDealershipRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/retention': typeof AppSettingsRetentionRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/vehicles/$vehicleId': typeof AppVehiclesVehicleIdRoute
  '/vehicles/new': typeof AppVehiclesNewRoute
  '/customers': typeof AppCustomersIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/vehicles': typeof AppVehiclesIndexRoute
  '/bookings/$bookingId/active': typeof AppBookingsBookingIdActiveRoute
  '/bookings/$bookingId/agreement': typeof AppBookingsBookingIdAgreementRoute
  '/bookings/$bookingId/condition': typeof AppBookingsBookingIdConditionRoute
  '/bookings/$bookingId/contact': typeof AppBookingsBookingIdContactRoute
  '/bookings/$bookingId/drive': typeof AppBookingsBookingIdDriveRoute
  '/bookings/$bookingId/licence': typeof AppBookingsBookingIdLicenceRoute
  '/bookings/$bookingId/return': typeof AppBookingsBookingIdReturnRoute
  '/drives/$driveId/active': typeof AppDrivesDriveIdActiveRoute
  '/drives/$driveId/agreement': typeof AppDrivesDriveIdAgreementRoute
  '/drives/$driveId/return': typeof AppDrivesDriveIdReturnRoute
  '/vehicles/$vehicleId/edit': typeof AppVehiclesVehicleIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/more': typeof AppMoreRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/join/$token': typeof JoinTokenRoute
  '/s/$token': typeof STokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/bookings/$bookingId': typeof AppBookingsBookingIdRoute
  '/_app/bookings/new': typeof AppBookingsNewRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/settings/agreements': typeof AppSettingsAgreementsRoute
  '/_app/settings/dealership': typeof AppSettingsDealershipRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/retention': typeof AppSettingsRetentionRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/staff': typeof AppSettingsStaffRoute
  '/_app/vehicles/$vehicleId': typeof AppVehiclesVehicleIdRoute
  '/_app/vehicles/new': typeof AppVehiclesNewRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/vehicles/': typeof AppVehiclesIndexRoute
  '/_app/bookings/$bookingId_/active': typeof AppBookingsBookingIdActiveRoute
  '/_app/bookings/$bookingId_/agreement': typeof AppBookingsBookingIdAgreementRoute
  '/_app/bookings/$bookingId_/condition': typeof AppBookingsBookingIdConditionRoute
  '/_app/bookings/$bookingId_/contact': typeof AppBookingsBookingIdContactRoute
  '/_app/bookings/$bookingId_/drive': typeof AppBookingsBookingIdDriveRoute
  '/_app/bookings/$bookingId_/licence': typeof AppBookingsBookingIdLicenceRoute
  '/_app/bookings/$bookingId_/return': typeof AppBookingsBookingIdReturnRoute
  '/_app/drives/$driveId_/active': typeof AppDrivesDriveIdActiveRoute
  '/_app/drives/$driveId_/agreement': typeof AppDrivesDriveIdAgreementRoute
  '/_app/drives/$driveId_/return': typeof AppDrivesDriveIdReturnRoute
  '/_app/vehicles/$vehicleId_/edit': typeof AppVehiclesVehicleIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sign-up'
    | '/calendar'
    | '/more'
    | '/notifications'
    | '/join/$token'
    | '/s/$token'
    | '/bookings/$bookingId'
    | '/bookings/new'
    | '/customers/$customerId'
    | '/settings/agreements'
    | '/settings/dealership'
    | '/settings/notifications'
    | '/settings/retention'
    | '/settings/security'
    | '/settings/staff'
    | '/vehicles/$vehicleId'
    | '/vehicles/new'
    | '/customers/'
    | '/settings/'
    | '/vehicles/'
    | '/bookings/$bookingId/active'
    | '/bookings/$bookingId/agreement'
    | '/bookings/$bookingId/condition'
    | '/bookings/$bookingId/contact'
    | '/bookings/$bookingId/drive'
    | '/bookings/$bookingId/licence'
    | '/bookings/$bookingId/return'
    | '/drives/$driveId/active'
    | '/drives/$driveId/agreement'
    | '/drives/$driveId/return'
    | '/vehicles/$vehicleId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/sign-up'
    | '/calendar'
    | '/more'
    | '/notifications'
    | '/join/$token'
    | '/s/$token'
    | '/'
    | '/bookings/$bookingId'
    | '/bookings/new'
    | '/customers/$customerId'
    | '/settings/agreements'
    | '/settings/dealership'
    | '/settings/notifications'
    | '/settings/retention'
    | '/settings/security'
    | '/settings/staff'
    | '/vehicles/$vehicleId'
    | '/vehicles/new'
    | '/customers'
    | '/settings'
    | '/vehicles'
    | '/bookings/$bookingId/active'
    | '/bookings/$bookingId/agreement'
    | '/bookings/$bookingId/condition'
    | '/bookings/$bookingId/contact'
    | '/bookings/$bookingId/drive'
    | '/bookings/$bookingId/licence'
    | '/bookings/$bookingId/return'
    | '/drives/$driveId/active'
    | '/drives/$driveId/agreement'
    | '/drives/$driveId/return'
    | '/vehicles/$vehicleId/edit'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/sign-up'
    | '/_app/calendar'
    | '/_app/more'
    | '/_app/notifications'
    | '/join/$token'
    | '/s/$token'
    | '/_app/'
    | '/_app/bookings/$bookingId'
    | '/_app/bookings/new'
    | '/_app/customers/$customerId'
    | '/_app/settings/agreements'
    | '/_app/settings/dealership'
    | '/_app/settings/notifications'
    | '/_app/settings/retention'
    | '/_app/settings/security'
    | '/_app/settings/staff'
    | '/_app/vehicles/$vehicleId'
    | '/_app/vehicles/new'
    | '/_app/customers/'
    | '/_app/settings/'
    | '/_app/vehicles/'
    | '/_app/bookings/$bookingId_/active'
    | '/_app/bookings/$bookingId_/agreement'
    | '/_app/bookings/$bookingId_/condition'
    | '/_app/bookings/$bookingId_/contact'
    | '/_app/bookings/$bookingId_/drive'
    | '/_app/bookings/$bookingId_/licence'
    | '/_app/bookings/$bookingId_/return'
    | '/_app/drives/$driveId_/active'
    | '/_app/drives/$driveId_/agreement'
    | '/_app/drives/$driveId_/return'
    | '/_app/vehicles/$vehicleId_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignUpRoute: typeof SignUpRoute
  JoinTokenRoute: typeof JoinTokenRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/more': {
      id: '/_app/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof AppMoreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/bookings/$bookingId': {
      id: '/_app/bookings/$bookingId'
      path: '/bookings/$bookingId'
      fullPath: '/bookings/$bookingId'
      preLoaderRoute: typeof AppBookingsBookingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/new': {
      id: '/_app/bookings/new'
      path: '/bookings/new'
      fullPath: '/bookings/new'
      preLoaderRoute: typeof AppBookingsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/agreements': {
      id: '/_app/settings/agreements'
      path: '/settings/agreements'
      fullPath: '/settings/agreements'
      preLoaderRoute: typeof AppSettingsAgreementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/dealership': {
      id: '/_app/settings/dealership'
      path: '/settings/dealership'
      fullPath: '/settings/dealership'
      preLoaderRoute: typeof AppSettingsDealershipRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/retention': {
      id: '/_app/settings/retention'
      path: '/settings/retention'
      fullPath: '/settings/retention'
      preLoaderRoute: typeof AppSettingsRetentionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/staff': {
      id: '/_app/settings/staff'
      path: '/settings/staff'
      fullPath: '/settings/staff'
      preLoaderRoute: typeof AppSettingsStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicles/': {
      id: '/_app/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof AppVehiclesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicles/$vehicleId': {
      id: '/_app/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof AppVehiclesVehicleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicles/new': {
      id: '/_app/vehicles/new'
      path: '/vehicles/new'
      fullPath: '/vehicles/new'
      preLoaderRoute: typeof AppVehiclesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/$bookingId_/active': {
      id: '/_app/bookings/$bookingId_/active'
      path: '/bookings/$bookingId/active'
      fullPath: '/bookings/$bookingId/active'
      preLoaderRoute: typeof AppBookingsBookingIdActiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/$bookingId_/agreement': {
      id: '/_app/bookings/$bookingId_/agreement'
      path: '/bookings/$bookingId/agreement'
      fullPath: '/bookings/$bookingId/agreement'
      preLoaderRoute: typeof AppBookingsBookingIdAgreementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/$bookingId_/condition': {
      id: '/_app/bookings/$bookingId_/condition'
      path: '/bookings/$bookingId/condition'
      fullPath: '/bookings/$bookingId/condition'
      preLoaderRoute: typeof AppBookingsBookingIdConditionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/$bookingId_/contact': {
      id: '/_app/bookings/$bookingId_/contact'
      path: '/bookings/$bookingId/contact'
      fullPath: '/bookings/$bookingId/contact'
      preLoaderRoute: typeof AppBookingsBookingIdContactRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/$bookingId_/drive': {
      id: '/_app/bookings/$bookingId_/drive'
      path: '/bookings/$bookingId/drive'
      fullPath: '/bookings/$bookingId/drive'
      preLoaderRoute: typeof AppBookingsBookingIdDriveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/$bookingId_/licence': {
      id: '/_app/bookings/$bookingId_/licence'
      path: '/bookings/$bookingId/licence'
      fullPath: '/bookings/$bookingId/licence'
      preLoaderRoute: typeof AppBookingsBookingIdLicenceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/$bookingId_/return': {
      id: '/_app/bookings/$bookingId_/return'
      path: '/bookings/$bookingId/return'
      fullPath: '/bookings/$bookingId/return'
      preLoaderRoute: typeof AppBookingsBookingIdReturnRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/drives/$driveId_/active': {
      id: '/_app/drives/$driveId_/active'
      path: '/drives/$driveId/active'
      fullPath: '/drives/$driveId/active'
      preLoaderRoute: typeof AppDrivesDriveIdActiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/drives/$driveId_/agreement': {
      id: '/_app/drives/$driveId_/agreement'
      path: '/drives/$driveId/agreement'
      fullPath: '/drives/$driveId/agreement'
      preLoaderRoute: typeof AppDrivesDriveIdAgreementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/drives/$driveId_/return': {
      id: '/_app/drives/$driveId_/return'
      path: '/drives/$driveId/return'
      fullPath: '/drives/$driveId/return'
      preLoaderRoute: typeof AppDrivesDriveIdReturnRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicles/$vehicleId_/edit': {
      id: '/_app/vehicles/$vehicleId_/edit'
      path: '/vehicles/$vehicleId/edit'
      fullPath: '/vehicles/$vehicleId/edit'
      preLoaderRoute: typeof AppVehiclesVehicleIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCalendarRoute: typeof AppCalendarRoute
  AppMoreRoute: typeof AppMoreRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppBookingsBookingIdRoute: typeof AppBookingsBookingIdRoute
  AppBookingsNewRoute: typeof AppBookingsNewRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppSettingsAgreementsRoute: typeof AppSettingsAgreementsRoute
  AppSettingsDealershipRoute: typeof AppSettingsDealershipRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsRetentionRoute: typeof AppSettingsRetentionRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsStaffRoute: typeof AppSettingsStaffRoute
  AppVehiclesVehicleIdRoute: typeof AppVehiclesVehicleIdRoute
  AppVehiclesNewRoute: typeof AppVehiclesNewRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppVehiclesIndexRoute: typeof AppVehiclesIndexRoute
  AppBookingsBookingIdActiveRoute: typeof AppBookingsBookingIdActiveRoute
  AppBookingsBookingIdAgreementRoute: typeof AppBookingsBookingIdAgreementRoute
  AppBookingsBookingIdConditionRoute: typeof AppBookingsBookingIdConditionRoute
  AppBookingsBookingIdContactRoute: typeof AppBookingsBookingIdContactRoute
  AppBookingsBookingIdDriveRoute: typeof AppBookingsBookingIdDriveRoute
  AppBookingsBookingIdLicenceRoute: typeof AppBookingsBookingIdLicenceRoute
  AppBookingsBookingIdReturnRoute: typeof AppBookingsBookingIdReturnRoute
  AppDrivesDriveIdActiveRoute: typeof AppDrivesDriveIdActiveRoute
  AppDrivesDriveIdAgreementRoute: typeof AppDrivesDriveIdAgreementRoute
  AppDrivesDriveIdReturnRoute: typeof AppDrivesDriveIdReturnRoute
  AppVehiclesVehicleIdEditRoute: typeof AppVehiclesVehicleIdEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCalendarRoute: AppCalendarRoute,
  AppMoreRoute: AppMoreRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppIndexRoute: AppIndexRoute,
  AppBookingsBookingIdRoute: AppBookingsBookingIdRoute,
  AppBookingsNewRoute: AppBookingsNewRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppSettingsAgreementsRoute: AppSettingsAgreementsRoute,
  AppSettingsDealershipRoute: AppSettingsDealershipRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsRetentionRoute: AppSettingsRetentionRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsStaffRoute: AppSettingsStaffRoute,
  AppVehiclesVehicleIdRoute: AppVehiclesVehicleIdRoute,
  AppVehiclesNewRoute: AppVehiclesNewRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppVehiclesIndexRoute: AppVehiclesIndexRoute,
  AppBookingsBookingIdActiveRoute: AppBookingsBookingIdActiveRoute,
  AppBookingsBookingIdAgreementRoute: AppBookingsBookingIdAgreementRoute,
  AppBookingsBookingIdConditionRoute: AppBookingsBookingIdConditionRoute,
  AppBookingsBookingIdContactRoute: AppBookingsBookingIdContactRoute,
  AppBookingsBookingIdDriveRoute: AppBookingsBookingIdDriveRoute,
  AppBookingsBookingIdLicenceRoute: AppBookingsBookingIdLicenceRoute,
  AppBookingsBookingIdReturnRoute: AppBookingsBookingIdReturnRoute,
  AppDrivesDriveIdActiveRoute: AppDrivesDriveIdActiveRoute,
  AppDrivesDriveIdAgreementRoute: AppDrivesDriveIdAgreementRoute,
  AppDrivesDriveIdReturnRoute: AppDrivesDriveIdReturnRoute,
  AppVehiclesVehicleIdEditRoute: AppVehiclesVehicleIdEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SignUpRoute: SignUpRoute,
  JoinTokenRoute: JoinTokenRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
